module.exports = __webpack_public_path__ + "img/产业园信息管理平台1.8e2fa871.png";